import Parser from 'html-react-parser';
import './styles.scss';
import l from '../../../../lang';
import { openNewTabAndFocus } from '../../../../utils';
import ButtonLink from '../../../common/button-link';
import { Urls } from '../../../../config/urls';
import { segmentIntegrationsApiIntegrationPageLinkDocs } from '../../../../utils/analytics';

const AddForAPI = () => {
  return (
    <div className="add-for-api">
      <div className="add-for-api__desc">
        <div>{l('paymentIntegration.apiIntegration.desc')}</div>
        <p>
          <span>{Parser(l('paymentIntegration.moreInfo'))} </span>
          <ButtonLink
            text={l('paymentIntegration.moreInfo.ourDocumentation')}
            onClick={() => {
              segmentIntegrationsApiIntegrationPageLinkDocs();
              openNewTabAndFocus(Urls.docs.apiIntegration)
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default AddForAPI;
